import { NgModule } from '@angular/core';
import { TranslateModule } from './translate/translate.module';
import { ToolbarModule } from '../routing/navigation/components/toolbar/toolbar.module';
import { IncPageModule } from './components/inc-page.module';

@NgModule({
    imports: [TranslateModule, ToolbarModule, IncPageModule],
    exports: [TranslateModule, ToolbarModule, IncPageModule],
})
export class NameModule { }
